import React from 'react';
import { useTranslation } from 'react-i18next';

import { CircleRescue } from '@/assets/icons/circle-rescue';
import InfoSmallIcon from '@/assets/icons/info-small';
import { Text } from '@/components/TextComponent';
import { Box, TouchableBox } from '@/components/lib/components';
import { useAlerts } from '@/feature/alerts/hooks/use-alerts';
import { designSystem } from '@/styles/styles';

export const BetSelectionRevivedInfo = () => {
    const { t } = useTranslation(['bets']);
    const { showInfoSheet } = useAlerts();

    const handleInfoPress = () =>
        showInfoSheet({
            title: t('rescued_picks'),
            description: t('rescued_picks_desc'),
            buttonLabel: t('got_it'),
            icon: <CircleRescue width={72} height={72} />,
        });

    return (
        <Box flexDirection="row" alignItems="center" gap="s4" paddingVertical="s2">
            <Text variant="titleSmall" color="neutral300">
                {t('rescued')}
            </Text>
            <TouchableBox onPress={handleInfoPress}>
                <InfoSmallIcon
                    size={16}
                    color={designSystem.colors.neutral300}
                    fillColor={designSystem.colors.neutral300}
                />
            </TouchableBox>
        </Box>
    );
};
